export default {
  // Meta & Header
  siteTitle: 'CSSBuy Spreadsheet 2026 | Guias, Produtos, QC & Envio',
  siteDescription: 'Explore o CSSBuy Spreadsheet com guias de pesquisa de produtos, dicas de QC, informações de envio, comparações, recursos de segurança e guias práticos de compra.',
  navHome: 'Início',
  navShoppingGuide: 'Guia de Compras',
  navSpreadsheet: 'CSSBuy Spreadsheet',
  navReview: 'Review',
  navShipping: 'Envio',
  navGuide: 'Guia',
  navSafety: 'Segurança',
  navFAQ: 'FAQ',
  navCategories: 'Categorias',
  navDropdownCategories: 'Categorias de Produtos',
  navEnglish: 'English',
  navGerman: 'Deutsch',
  navPortuguese: 'Português',
  navOpen: 'Abrir menu',
  navClose: 'Fechar menu',

  // Hero Section
  heroH1: 'CSSBuy Spreadsheet: Encontre, Compare e Pesquise Produtos com Mais Facilidade',
  heroSubtitle: 'Explore o CSSBuy Spreadsheet para pesquisar produtos, comparar opções e entender melhor QC, armazenamento, envio e outros pontos importantes antes de comprar.',
  heroCtaPrimary: 'Explorar CSSBuy Spreadsheet',
  heroCtaSecondary: 'Ver Guia CSSBuy',
  heroTrust: 'Atualizado em 2026 · Guias Práticos · QC · Shipping · Comparações · Segurança',

  // What is CSSBuy Spreadsheet
  whatIsH2: 'O que é o CSSBuy Spreadsheet?',
  whatIsText: 'O CSSBuy Spreadsheet é um recurso organizado para pesquisa de produtos. Explore categorias, compare opções e consulte guias sobre QC, preços, armazenamento e envio para tomar decisões mais informadas.',
  whatIsCta: 'Ver CSSBuy Spreadsheet',

  // Benefits
  benefitsH2: 'Pesquise melhor antes de comprar',
  benefit1Title: 'Pesquisa Organizada',
  benefit1Text: 'Encontre categorias e informações relevantes em um único lugar.',
  benefit2Title: 'Compare Opções',
  benefit2Text: 'Compare produtos, métodos e alternativas antes de decidir.',
  benefit3Title: 'Guias Práticos',
  benefit3Text: 'Aprenda sobre QC, warehouse, shipping e custos.',
  benefit4Title: 'Mais Segurança',
  benefit4Text: 'Confira recomendações importantes no Safety Center.',

  // Categories
  categoriesH2: 'Explore Categorias Populares',
  categoriesCta: 'Explorar Todas as Categorias',
  catShoes: 'Shoes',
  catHoodies: 'Hoodies/Sweaters',
  catTshirts: 'T-Shirts',
  catJackets: 'Jackets',
  catPants: 'Pants/Shorts',
  catHeadwear: 'Headwear',
  catSets: 'Sets',
  catUnderwear: 'Underwear/Underpants',
  catJersey: 'Jersey',
  catAccessories: 'Accessories',
  catBags: 'Bags',
  catBelts: 'Belts',
  catPerfumes: 'Perfumes',
  catOther: 'Other Stuff',

  // How It Works
  howItWorksH2: 'Como usar o CSSBuy Spreadsheet',
  step1: 'Escolha uma categoria',
  step2: 'Pesquise produtos',
  step3: 'Compare informações',
  step4: 'Confira QC',
  step5: 'Leia o guia relacionado',
  step6: 'Continue sua pesquisa no site principal',
  howItWorksNote: 'Preços, disponibilidade, políticas e opções de envio podem mudar. Sempre confirme as informações atuais antes de comprar.',

  // Review Section
  reviewH2: 'CSSBuy Review: O que você precisa saber',
  reviewText: 'Confira nossa análise sobre recursos, QC, warehouse, shipping, custos e pontos importantes para quem está começando.',
  reviewCta: 'Ler CSSBuy Review',

  // Shipping Section
  shippingH2: 'CSSBuy Shipping Cost: Entenda o custo total',
  shippingText: 'O custo de envio pode variar conforme peso, dimensões, destino e método escolhido. Veja nosso guia para entender os principais fatores que influenciam o custo.',
  shippingCta: 'Ver Guia de Shipping',

  // Safety Section
  safetyH2: 'Pesquise com mais segurança',
  safetyText: 'Verifique URLs, informações do produto, QC, pagamentos e políticas antes de realizar qualquer transação. Nunca compartilhe senhas ou informações confidenciais.',
  safetyCta: 'Abrir Safety Center',
  safetyCheckUrl: 'Verificar URL',
  safetyProtectPassword: 'Proteger senha',
  safetyVerifyPayment: 'Verificar pagamento',
  safetyReviewQC: 'Revisar QC',
  safetyCheckShipping: 'Verificar envio',
  safetyKeepRecords: 'Manter registros',

  // Final CTA
  finalCtaH2: 'Pronto para começar sua pesquisa?',
  finalCtaText: 'Explore o CSSBuy Spreadsheet e encontre guias, categorias, comparações e recursos para organizar melhor sua pesquisa.',
  finalCtaButton: 'Explorar CSSBuy Spreadsheet',

  // Articles Preview
  articlesH2: 'Artigos e Guias Recentes',
  articlesSubtitle: 'Guias completos e artigos originais sobre pesquisa de produtos, QC, shipping e segurança.',
  articlesCta: 'Ver Todos os Artigos',
  article1Title: 'CSSBuy Spreadsheet 2026: Guia Completo',
  article1Desc: 'Descubra como usar o CSSBuy Spreadsheet para pesquisar produtos de forma organizada e eficiente.',
  article2Title: 'CSSBuy Shipping Guide: Tudo sobre envio',
  article2Desc: 'Entenda os métodos de envio, custos, prazos e como escolher a melhor opção.',
  article3Title: 'CSSBuy QC Guide: Verificação de qualidade',
  article3Desc: 'Aprenda a analisar fotos de QC e verificar a qualidade dos produtos antes de enviar.',

  // FAQ
  faqH2: 'Perguntas Frequentes',
  faq1Q: 'O que é o CSSBuy Spreadsheet?',
  faq1A: 'O CSSBuy Spreadsheet é um recurso organizado que ajuda na pesquisa de produtos, comparação de opções e consulta de guias sobre QC, preços, armazenamento e envio.',
  faq2Q: 'O CSSBuy é seguro?',
  faq2A: 'A segurança depende de como você usa o serviço. Siga nossas recomendações no Safety Center, verifique URLs, proteja suas senhas e revise sempre o QC antes de confirmar envios.',
  faq3Q: 'Como funciona o shipping?',
  faq3A: 'O custo de envio varia conforme peso, dimensões, destino e método escolhido. Consulte nosso guia completo para entender os fatores que influenciam o custo total.',
  faq4Q: 'Quais categorias estão disponíveis?',
  faq4A: 'Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes e Other Stuff.',

  // Footer
  footerLinks: 'Links Úteis',
  footerGuides: 'Guias',
  footerCategories: 'Categorias',
  footerLegal: 'Legal',
  footerAbout: 'Sobre',
  footerContact: 'Contato',
  footerDisclaimer: 'Disclaimer',
  footerPrivacy: 'Política de Privacidade',
  footerTerms: 'Termos de Uso',
  footerEditorial: 'Política Editorial',
  footerSpreadsheet: 'CSSBuy Spreadsheet',
  footerReview: 'CSSBuy Review',
  footerShippingGuide: 'Guia de Shipping',
  footerQCGuide: 'Guia de QC',
  footerCouponGuide: 'Guia de Coupons',
  footerWarehouseGuide: 'Guia de Warehouse',
  footerCopyright: '© 2026 CSSBuy Spreadsheet. Todos os direitos reservados.',
  footerDisclaimerText: 'Este site é um recurso independente de informação. Não garante produtos, vendedores, preços, serviços de envio, reembolsos ou transações de terceiros.',

  // Buttons
  btnMainSite: 'CSSBuy Spreadsheet',
  btnBuyNow: 'Buy It Now',
  btnReadMore: 'Ler mais',
  btnExplore: 'Explorar',
  btnLearnMore: 'Saiba mais',

  // Disclaimer
  infoDisclaimer: 'Informações podem mudar. Verifique os detalhes atuais antes de fazer um pedido.',

  // Table headers
  tableFeature: 'Recurso',
  tableCssbuy: 'CSSBuy',
  tableSuperbuy: 'Superbuy',
  tableSugargoo: 'Sugargoo',
  tableCheck: 'Verificar',
  tableCompare: 'Comparar',

  // Breadcrumbs
  breadcrumbHome: 'Início',
  breadcrumbSpreadsheet: 'CSSBuy Spreadsheet',
  breadcrumbReview: 'Review',
  breadcrumbShipping: 'Shipping',
  breadcrumbGuide: 'Guia',
  breadcrumbSafety: 'Segurança',
  breadcrumbFAQ: 'FAQ',
  breadcrumbCategories: 'Categorias',
  breadcrumbArticles: 'Artigos',

  // Comparison page
  comparisonH1: 'CSSBuy vs Alternativas: Comparação Completa',
  comparisonIntro: 'Compare CSSBuy com outros agentes de compra para encontrar a melhor opção para suas necessidades.',
  comparisonProductResearch: 'Pesquisa de Produtos',
  comparisonQC: 'QC',
  comparisonWarehouse: 'Warehouse',
  comparisonShipping: 'Envio',
  comparisonBeginnerFriendly: 'Amigável para Iniciantes',
  comparisonNote: 'Informações podem mudar. Verifique os detalhes atuais antes de fazer um pedido.',

  // Shipping page
  shippingH1: 'CSSBuy Shipping Cost: Guia Completo',
  shippingIntro: 'Entenda todos os fatores que influenciam o custo de envio do CSSBuy.',
  shippingFactorWeight: 'Peso do pacote',
  shippingFactorDimensions: 'Dimensões',
  shippingFactorDestination: 'Destino',
  shippingFactorMethod: 'Método de envio',
  shippingFactorInsurance: 'Seguro (opcional)',

  // QC Page
  qcH1: 'CSSBuy QC Guide: Verificação de Qualidade',
  qcIntro: 'Aprenda a analisar fotos de QC e verificar a qualidade dos produtos antes de enviar.',
  qcStep1: 'Verifique fotos detalhadas',
  qcStep2: 'Compare com fotos do vendedor',
  qcStep3: 'Inspecione costuras e materiais',
  qcStep4: 'Verifique logos e etiquetas',
  qcStep5: 'Confirme tamanhos e medidas',

  // Safety page
  safetyH1: 'CSSBuy Safety Center: Pesquise com Segurança',
  safetyIntro: 'Recomendações importantes para proteger suas informações e transações.',
  safetyUrlVerify: 'Verificação de URL',
  safetyUrlVerifyText: 'Sempre verifique se o site é oficial antes de fazer login ou pagamentos.',
  safetyPassword: 'Proteção de Senha',
  safetyPasswordText: 'Nunca compartilhe suas senhas. Use senhas únicas e autenticação de dois fatores.',
  safetyPayment: 'Segurança de Pagamento',
  safetyPaymentText: 'Verifique métodos de pagamento seguros e confirme URLs antes de transações.',
  safetyProductInfo: 'Informações do Produto',
  safetyProductInfoText: 'Verifique detalhes do produto, QC e fotos antes de confirmar compras.',
  safetyCustoms: 'Alfândega',
  safetyCustomsText: 'Entenda as regras alfandegárias do seu país antes de enviar.',
  safetyRecords: 'Registros de Transação',
  safetyRecordsText: 'Mantenha registros de todos os pedidos, pagamentos e envios.',

  // Guide page
  guideH1: 'CSSBuy Guide: Guia Completo para Iniciantes',
  guideIntro: 'Tudo o que você precisa saber para começar a usar o CSSBuy com segurança e eficiência.',
  guideStep1Title: 'Crie sua conta',
  guideStep1Text: 'Registre-se no site oficial e configure sua conta com informações corretas.',
  guideStep2Title: 'Pesquise produtos',
  guideStep2Text: 'Use o CSSBuy Spreadsheet para encontrar e organizar suas pesquisas.',
  guideStep3Title: 'Verifique QC',
  guideStep3Text: 'Analise fotos de qualidade antes de aprovar o envio.',
  guideStep4Title: 'Escolha o envio',
  guideStep4Text: 'Selecione o método de envio adequado ao seu destino e orçamento.',
  guideStep5Title: 'Acompanhe o pedido',
  guideStep5Text: 'Monitore o status do envio até a entrega final.',

  // Spreadsheet page
  spreadsheetH1: 'CSSBuy Spreadsheet: Recurso Completo de Pesquisa',
  spreadsheetIntro: 'O CSSBuy Spreadsheet é a ferramenta central para organizar e comparar suas pesquisas de produtos.',
  spreadsheetFeature1: 'Categorias organizadas',
  spreadsheetFeature2: 'Comparações de produtos',
  spreadsheetFeature3: 'Informações de QC',
  spreadsheetFeature4: 'Guias de envio',
  spreadsheetFeature5: 'Dicas de segurança',
  spreadsheetFeature6: 'Atualizações regulares',
  spreadsheetCta: 'Explorar Agora',

  // Review page
  reviewH1: 'CSSBuy Review 2026: Análise Completa',
  reviewIntro: 'Análise detalhada dos recursos, serviços e pontos importantes do CSSBuy.',
  reviewPros: 'Pontos Positivos',
  reviewCons: 'Pontos a Considerar',
  reviewPro1: 'Interface organizada para pesquisa',
  reviewPro2: 'Múltiplas opções de envio',
  reviewPro3: 'Sistema de QC para verificação',
  reviewPro4: 'Warehouse para armazenamento',
  reviewCon1: 'Custo de envio pode variar muito',
  reviewCon2: 'Prazos dependem do método escolhido',
  reviewCon3: 'Políticas podem mudar sem aviso',
  reviewCon4: 'Necessário verificar informações atuais',

  // Article page
  articlePublished: 'Publicado',
  articleUpdated: 'Atualizado',
  articleReadTime: 'min de leitura',
  articleRelated: 'Artigos Relacionados',
  articleTldr: 'TL;DR',
  articleContents: 'Conteúdo',
  articleTips: 'Dicas Importantes',
  articleSafety: 'Segurança',
  articleFaq: 'Perguntas Frequentes',

  // Beginners article
  beginnersH1: 'CSSBuy Spreadsheet para Iniciantes: Guia Passo a Passo',
  beginnersIntro: 'Este guia completo ensina como usar o CSSBuy Spreadsheet para pesquisar produtos de forma organizada e eficiente.',
  beginnersSection1H2: 'O que é o CSSBuy Spreadsheet?',
  beginnersSection1Text: 'O CSSBuy Spreadsheet é uma ferramenta organizada que permite pesquisar produtos, comparar opções e consultar informações sobre QC, envio, warehouse e custos em um único lugar.',
  beginnersSection2H2: 'Como começar',
  beginnersSection2Text: 'Para começar, familiarize-se com as categorias disponíveis. Cada categoria contém informações organizadas sobre produtos relevantes. Use o menu de categorias para navegar entre Shoes, Hoodies, T-Shirts, Jackets e outras opções.',
  beginnersSection3H2: 'Como pesquisar produtos',
  beginnersSection3Text: 'A pesquisa de produtos no CSSBuy Spreadsheet é intuitiva. Escolha uma categoria, explore as opções disponíveis e compare diferentes produtos antes de tomar uma decisão. Sempre verifique as informações atualizadas antes de comprar.',
  beginnersSection4H2: 'Dicas para iniciantes',
  beginnersSection4Text: 'Sempre verifique o QC antes de aprovar envios. Compare preços e métodos de envio. Mantenha registros de todas as transações. Use o Safety Center para verificar recomendações importantes.',
  beginnersSection5H2: 'Comparação: CSSBuy vs Alternativas',
  beginnersSection5Text: 'Ao comparar CSSBuy com outras opções, considere fatores como pesquisa de produtos, QC, warehouse, envio e facilidade de uso para iniciantes.',

  // Common
  readMore: 'Ler mais',
  goToMainSite: 'Ir para o site principal',
  search: 'Pesquisar',
  share: 'Compartilhar',
  close: 'Fechar',
  loading: 'Carregando...',
  error: 'Erro',
  retry: 'Tentar novamente',

  // Not Found
  notFoundTitle: 'Página não encontrada',
  notFoundText: 'A página que você está procurando não existe.',
  notFoundCta: 'Voltar para o início',
};